/*
 *  Forces trailing slash on passed slug
 *  If slug ends in trailing slash, it does not append one
 *  If non string slug is passed, empty string is returned
 * */
export const forceTrailingSlash = (slug: string): string => {
  let urlWithTrailingSlash = '';

  if (typeof slug === 'string' || (slug as unknown) instanceof String) {
    urlWithTrailingSlash = slug.replace(/\/$|$/, `/`);
  }

  return urlWithTrailingSlash;
};

/*
 *  Returns url parameter name by paramName
 *  if paraName does not exist in URL it returns null
 * */
export function getUrlParam(url, paramName): string | null {
  const urlObj = new URL(url);
  const searchParams = new URLSearchParams(urlObj.search);

  return searchParams.get(paramName);
}
